import produce from "immer";

import * as AuthService from "services/auth";
import { AppModel } from "types/app.d";
import { RootModel } from "types/rootModel.d";
import { createModel, RematchDispatch } from "@rematch/core";

export const storeName = "app";

const initialState: AppModel = {
  user: undefined,
  languages: undefined,
};

export const app: any = createModel<RootModel>()({
  name: storeName,
  state: initialState,
  reducers: {
    enableLigthTheme: produce((state, payload) => {
      state.layoutState.themeLight = payload;
    }),
    collapseMenu: produce((state, payload) => {
      state.layoutState.menuCollapsed = payload;
    }),
    updateUserDetail(state: any, payload: any) {
      return {
        ...state,
        user: payload,
      };
    },
    updateLanguages(state: any, payload: any) {
      return {
        ...state,
        languages: payload,
      };
    },
  },
  effects: (dispatch: RematchDispatch<typeof app>) => ({
    getUserDetailAsync() {
      return AuthService.getUserDetail().then((res: any) => {
        const { data } = res;
        data.permissions = data.authorities
          // .flatMap((r: any) => r.permissions)
          .map((item: any) => item?.authority);
        dispatch[storeName].updateUserDetail(data);
        return data;
      });
    },
  }),
});

export default app;
